var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var FractionDigitService = /** @class */ (function () {
    function FractionDigitService() {
        this.zeroText = '0';
    }
    /**
     * 左补齐字符串
     * @param number  要处理的数字
     * @param fillLength 要补齐的长度
     * @param char 要补齐的字符
     */
    FractionDigitService.prototype.padLeft = function (number, fillLength, char) {
        // eslint-disable-next-line no-new-wrappers
        var result = new String(number);
        char = char ? char : this.zeroText; // 默认补0
        var currentLength = result.length;
        while (currentLength < fillLength) {
            result = char + result;
            currentLength++;
        }
        return result.toString();
    };
    /**
     * 右补齐字符串
     * @param number  要处理的数字
     * @param fillLength 要补齐的长度
     * @param char  要补齐的字符
     */
    FractionDigitService.prototype.padRight = function (number, fillLength, char) {
        // eslint-disable-next-line no-new-wrappers
        var result = new String(number);
        char = char ? char : this.zeroText; // 默认补0
        var currentLength = result.length;
        while (currentLength < fillLength) {
            result = result + char;
            currentLength++;
        }
        return result.toString();
    };
    /**
     * 左移小数点位置（用于数学计算，相当于除以Math.pow(10,scale)）
     * @param fractionDigits 要移位的刻度
     * @return
     */
    FractionDigitService.prototype.movePointLeft = function (number, fractionDigits) {
        if (fractionDigits <= 0) {
            return number;
        }
        // eslint-disable-next-line no-new-wrappers
        var numberText = new String(number);
        var decimalParts = numberText.split('.');
        var intergerPart = decimalParts[0] ? decimalParts[0] : '';
        var fractionPart = decimalParts[1] ? decimalParts[1] : '';
        var fractionPointText = '.';
        var minusText = '';
        if (intergerPart.slice(0, 1) === '-') {
            intergerPart = intergerPart.slice(1);
            minusText = '-';
        }
        if (intergerPart.length <= fractionDigits) {
            fractionPointText = '0.';
            intergerPart = this.padLeft(intergerPart, fractionDigits, '0');
        }
        return minusText +
            intergerPart.slice(0, -fractionDigits) +
            fractionPointText +
            intergerPart.slice(-fractionDigits) +
            fractionPart;
    };
    /**
     * 右移小数点位置（用于数学计算，相当于乘以Math.pow(10,scale)）
     * @param number  要处理的数字
     * @param fractionDigits 要移位的刻度
     */
    FractionDigitService.prototype.movePointRight = function (number, fractionDigits) {
        if (fractionDigits <= 0) {
            return number;
        }
        // eslint-disable-next-line no-new-wrappers
        var numberText = new String(number);
        var decimalParts = numberText.split('.');
        var intergerPart = decimalParts[0] ? decimalParts[0] : '';
        var fractionPart = decimalParts[1] ? decimalParts[1] : '';
        var fractionPointText = '.';
        if (fractionPart.length <= fractionDigits) {
            fractionPointText = '';
            fractionPart = this.padRight(fractionPart, fractionDigits, '0');
        }
        return intergerPart +
            fractionPart.slice(0, fractionDigits) +
            fractionPointText +
            fractionPart.slice(fractionDigits, fractionPart.length);
    };
    /**
     * 移动小数点位置（用于数学计算，相当于（乘以/除以）Math.pow(10,scale)）
     * @param number  要处理的数字
     * @param fractionDigits  要移位的刻度（正数表示向右移；负数表示向左移动；0返回原值）
     */
    FractionDigitService.prototype.movePoint = function (number, fractionDigits) {
        return fractionDigits >= 0
            ? this.movePointRight(number, fractionDigits)
            : this.movePointLeft(number, -fractionDigits);
    };
    /**
     * 按照指定的小数位，对数字进行四舍五入计算
     * @param number 要处理的数字
     * @param fractionDigits 指定的小数位
     */
    FractionDigitService.prototype.roundingToFixedFractionDigits = function (number, fractionDigits) {
        // eslint-disable-next-line no-new-wrappers
        var numberText = new String(number);
        var fractionPointIndex = numberText.indexOf('.') + 1;
        var currentFractionDigits = numberText.length - fractionPointIndex;
        if (fractionPointIndex >= 1 && currentFractionDigits > fractionDigits) {
            var result = +this.movePoint(numberText, fractionDigits);
            var roundingNumber = Number(numberText.substr(fractionPointIndex + fractionDigits, 1));
            if (roundingNumber >= 5 && number >= 0 || roundingNumber < 5 && number < 0) {
                result = Math.ceil(result);
            }
            else {
                result = Math.floor(result);
            }
            return this.movePoint(result, -fractionDigits);
        }
        return number;
    };
    FractionDigitService = __decorate([
        Injectable()
    ], FractionDigitService);
    return FractionDigitService;
}());
export { FractionDigitService };
